import { Tabs } from 'antd'
import moment from 'moment'
import React from 'react'
import style from './style.module.scss'

const { TabPane } = Tabs

const List2 = ({ orders }) => {
  return (
    <div>
      <Tabs className={`${style.tabs} kit-tabs-bordered`} defaultActiveKey="1">
        <TabPane tab="Orders" key="1">
          <div className="text-gray-6">
            <ul className="list-unstyled">
              {orders &&
                orders.map(order => (
                  <li className="mb-3">
                    <div className={style.head}>
                      <p className={style.title}>
                        Table No {order.tableNo}
                        <strong className="text-black"> {order.orderType}</strong>
                      </p>
                      <time className={style.time}>{moment(order.updatedAt).fromNow()}</time>
                    </div>
                    {order.orderType === 'new' ? (
                      <p>New Order come on table No: {order.tableNo}</p>
                    ) : (
                      <p>Table No:{order.tableNo} order updated.</p>
                    )}
                  </li>
                ))}
            </ul>
          </div>
        </TabPane>
        <TabPane tab="Events" key="2">
          <div className="text-center mb-3 py-4 bg-light rounded">No Events</div>
        </TabPane>
        <TabPane tab="Actions" key="3">
          <div className="text-center mb-3 py-4 bg-light rounded">No Actions</div>
        </TabPane>
      </Tabs>
    </div>
  )
}

export default List2
